import {ComponentFactoryResolver, ComponentRef, Injectable, Injector, Type} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DynamicComponentService {

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private injector: Injector
  ) { }

  createComponent<T>(componentType: Type<T>, container: any): ComponentRef<T> {
    console.log('DynamicComponentService::createComponent() container = ', container);

    if (!container) {
      throw new Error('DynamicComponentService::createComponent() container is null');
    }

    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(componentType);
    const componentRef = componentFactory.create(this.injector);
    container.insert(componentRef.hostView);
    return componentRef;
  }
}
